// Celestria footer WebGL — Shopify-hosted lazy loader.
//
// All assets live in the Shopify theme Assets folder. Their hashed URLs are
// injected from Liquid into window.CELESTRIA_GL (see footer snippet).
// Engine scripts + patch data are fetched only when the footer nears the
// viewport, and rendering pauses whenever it scrolls away or the tab hides.

(function () {
  var CONTAINER_CLASS = "celestria-footer__bg";
  var CANVAS_ID = "glcanvas";

  var cfg = window.CELESTRIA_GL;
  if (!cfg) { console.error("[webgl-footer] window.CELESTRIA_GL config missing"); return; }

  var container = document.querySelector("." + CONTAINER_CLASS);
  if (!container) return;

  var booted = false;
  var patchRef = null;

  // Engine scripts must execute in this exact order.
  var SCRIPTS = [cfg.cables, cfg.cgl, cfg.ops, cfg.patch];

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = src;
      s.async = false;
      s.onload = resolve;
      s.onerror = function () { reject(new Error("Failed to load " + src)); };
      document.body.appendChild(s);
    });
  }

  function isVisible() {
    var r = container.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  }

  function boot() {
    if (booted) return;
    booted = true;

    SCRIPTS.reduce(function (chain, src) {
      return chain.then(function () { return loadScript(src); });
    }, Promise.resolve())
      .then(function () {
        var patchData = window.CABLES_FOOTER_PATCH;
        if (!patchData) throw new Error("patch data global not found");

        // Point the texture op at the Shopify-hosted hero image (hashed URL).
        (patchData.ops || []).forEach(function (op) {
          if (op.objName === "Ops.Gl.Texture_v2") {
            (op.portsIn || []).forEach(function (p) {
              if (p.name === "File") p.value = cfg.texture;
            });
          }
        });

        patchRef = new CABLES.Patch({
          patch: patchData,
          glCanvasId: CANVAS_ID,
          glCanvasResizeToParent: true,
          prefixAssetPath: "",
          onFinishedLoading: function () {
            if (isVisible()) patchRef.resume(); else patchRef.pause();
          }
        });
      })
      .catch(function (err) { console.error("[webgl-footer]", err); });
  }

  // Boot when the footer is within 300px of the viewport.
  var bootObserver = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) { bootObserver.disconnect(); boot(); }
  }, { rootMargin: "300px" });
  bootObserver.observe(container);

  // Pause/resume as it enters and leaves the screen.
  var runObserver = new IntersectionObserver(function (entries) {
    if (!patchRef) return;
    if (entries[0].isIntersecting) patchRef.resume(); else patchRef.pause();
  }, { threshold: 0 });
  runObserver.observe(container);

  // Stop when the tab is hidden.
  document.addEventListener("visibilitychange", function () {
    if (!patchRef) return;
    if (document.hidden) patchRef.pause();
    else if (isVisible()) patchRef.resume();
  });
})();
